import React, { useState } from 'react'
import { connect } from 'react-redux'
import { useForm } from 'react-hook-form'
import PropTypes from 'prop-types'
import { InputAdornment, IconButton } from '@mui/material'
import * as validators from '../../utils/validators'

import {
  formContainer,
  titleContainer,
  mainTitle,
  buttonContainer,
  passwordInput
} from './styles/LoginForm.style'

import EyeIcon from './EyeIcon'
import EyeClosedIcon from './EyeClosedIcon'
import { Button } from '../shared/styles/Button.style'
import Input from '../shared/Input'

const LoginForm = ({
  onSubmit,
  isSubmitting,
  translation,
  lang
}) => {
  const required = lang === 'pt-BR' ? validators.requiredPT : validators.requiredES
  const emailOrFractalId = lang === 'pt-BR' ? validators.emailOrFractalIdPT : validators.emailOrFractalIdES
  const [showPassword, setShowPassword] = useState(false)
  const { control, handleSubmit } = useForm({
    defaultValues: {
      login: '',
      password: ''
    }
  })
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }
  const passwordInputType = showPassword ? 'text' : 'password'
  return (
    <form className={formContainer} onSubmit={handleSubmit(onSubmit)}>
      <header className={titleContainer}>
        <h1 className={mainTitle}>Login</h1>
      </header>

      <div className={passwordInput}>
        <Input
          control={control}
          name='login'
          rules={{ validate: validators.composeValidators(required, emailOrFractalId) }}
          placeholder={translation('login')['fractalIdPlaceholder']}
          type='text'
          block
        />
        <Input
          control={control}
          name='password'
          rules={{ validate: validators.composeValidators(required) }}
          placeholder={translation('login')['passwordPlaceholder']}
          type={passwordInputType}
          block
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton
                    aria-label='toggle password visibility'
                    onClick={togglePasswordVisibility}
                    edge='end'
                    size='small'
                    style={{ padding: 4 }}
                  >
                    {showPassword ? <EyeIcon /> : <EyeClosedIcon />}
                  </IconButton>
                </InputAdornment>
              )
            }
          }}
        />
      </div>
      <div className={buttonContainer}>
        <Button
          type='submit'
          disabled={isSubmitting}
        >
          {translation('login')['loginButton']}
        </Button>
      </div>
    </form>
  )
}

LoginForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  translation: PropTypes.func.isRequired,
  lang: PropTypes.string
}

const mapStateToProps = ({ auth }) => ({
  isSubmitting: auth.isFetching
})

export default connect(mapStateToProps)(LoginForm)
